<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Vehicle Detail</li>
		</ol>

        <h1 class="page-header">Vehicle Detail</h1>
        <hr>

         <panel class="border border-secondary filter-option-panel" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="filter-option-card">
                <!-- Row 1: Search string, Vehicle Type, Location, Color -->
                <div class="row filter-row mb-3">
                    <!-- 1. Search (Frame No / QR Code) -->
                    <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                        <div class="search-input-group">
                            <div class="dropdown search-dropdown">
                                <button
                                    type="button"
                                    class="btn search-dropdown-btn dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    {{searchOption.text[searchOption.selectedIndex]}} <span class="search-caret">▾</span>
                                </button>
                                <div class="dropdown-menu">
                                    <a
                                        class="dropdown-item searchOptions"
                                        v-for="(option, index) in searchOption.value"
                                        :key="index"
                                        @click="searchOption.selectedIndex = index"
                                    >
                                        {{searchOption.text[index]}}
                                    </a>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="form-control search-text-input"
                                v-model="searchString"
                                placeholder="Enter here"
                            />
                        </div>
                    </div>

                    <!-- 2. Vehicle Type -->
                    <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                        <div class="filter-field-group">
                            <label class="filter-field-label vehicle-type-label">
                                <span>Vehicle</span>
                                <span>Type</span>
                            </label>
                            <div class="filter-field-control">
                                <MultiSelect
                                    v-model="filter.type"
                                    :options="filterOption.vehicleTypes"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :multiple="false"
                                    placeholder="Choose Type"
                                ></MultiSelect>
                            </div>
                        </div>
                    </div>

                    <!-- 3. Location -->
                    <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                        <div class="filter-field-group">
                            <label class="filter-field-label">Location</label>
                            <div class="filter-field-control">
                                <MultiSelect
                                    v-model="filter.location"
                                    :options="filterOption.location"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :multiple="false"
                                    placeholder="Choose Location"
                                ></MultiSelect>
                            </div>
                        </div>
                    </div>

                    <!-- 4. Color -->
                    <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                        <div class="filter-field-group">
                            <label class="filter-field-label">Color</label>
                            <div class="filter-field-control">
                                <MultiSelect
                                    v-model="selected.color"
                                    :options="filterOption.color"
                                    track-by="color_code"
                                    label="color_desc"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :multiple="false"
                                    placeholder="Choose Color"
                                ></MultiSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Row 2: Date, Start, End, Search Button -->
                <div class="row filter-row">
                    <!-- 1. Date Range -->
                    <div class="col-lg-3 col-md-6 col-12 mb-2 mb-lg-0">
                        <div class="filter-date-group">
                            <div class="date-checkbox-label">
                                <input
                                    type="checkbox"
                                    id="dateCheck"
                                    v-model="dateNotDisabled"
                                    class="date-checkbox-input"
                                />
                                <label for="dateCheck" class="date-checkbox-text">Date</label>
                            </div>
                            <div class="date-picker-control">
                                <date-range-picker
                                    id="dateTimeInput"
                                    v-model="dateRange"
                                    class="filter-date-range-picker"
                                    :class="{'disabled-picker': !dateNotDisabled}"
                                    opens="right"
                                >
                                    <div slot="input" slot-scope="picker" class="date-picker-slot-inner">
                                        <span class="date-range-text">
                                            {{ moment(dateRange.startDate).format("DD MMMM YYYY") }} - {{ moment(dateRange.endDate).format("DD MMMM YYYY") }}
                                        </span>
                                        <i class="fa fa-calendar date-calendar-icon"></i>
                                    </div>
                                </date-range-picker>
                            </div>
                        </div>
                    </div>

                    <!-- 2. Start & End Times -->
                    <div class="col-lg-5 col-md-6 col-12 mb-2 mb-lg-0">
                        <div class="filter-time-wrapper">
                            <!-- Start Time -->
                            <div class="filter-time-group">
                                <label class="filter-field-label">Start</label>
                                <div class="timepicker-control-wrapper">
                                    <vue-timepicker
                                        format="HH:mm"
                                        input-class="form-control filter-timepicker-input"
                                        input-width="148px"
                                        v-model="selected.start_hour"
                                        placeholder="00:00"
                                        :class="{'disabled-picker': !dateNotDisabled}"
                                    ></vue-timepicker>
                                </div>
                            </div>

                            <!-- End Time -->
                            <div class="filter-time-group">
                                <label class="filter-field-label">End</label>
                                <div class="timepicker-control-wrapper">
                                    <vue-timepicker
                                        format="HH:mm"
                                        input-class="form-control filter-timepicker-input"
                                        input-width="148px"
                                        v-model="selected.end_hour"
                                        placeholder="23:59"
                                        :class="{'disabled-picker': !dateNotDisabled}"
                                    ></vue-timepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 3. Search Button -->
                    <div class="col-lg-4 col-md-12 col-12 d-flex justify-content-end align-items-center">
                        <button
                            type="button"
                            class="btn btn-search-custom"
                            @click="search()"
                        >
                            Search
                        </button>
                    </div>
                </div>
            </div>
        </panel>
        

        <!--Line Chart-->
        <!-- <successVsfailChart class="mt-3" v-if="filterReady"></successVsfailChart> -->


        <!---Table Report Log Start-->
        <mappingTable class="mt-4" v-if="filterReady"></mappingTable>
    </div> 
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment';
    import * as am4core from "@amcharts/amcharts4/core";
    import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.umd.min.js'
    import MultiSelect from 'vue-multiselect';
    import $ from 'jquery'

    // import child components
    import mappingTable from './childComponents/mappingTable'
    
    export default{
        data(){
            var startDate = moment().startOf('month')._d;
            // var compareDate = {
            //     startDate :  new moment().subtract(1, 'months').date(1),
            //     endDate : new moment().date(0)
            // }

            var filter = {
                // start_date  : moment(startDate).format('YYYY-MM-DD'),
                // end_date : new moment().format('YYYY-MM-DD'),
                // frame_no : '',
                // qrcode : '',
                type : '',
                location : '',
                color : '',
                // start_hour : "00:00",
                // end_hour : "23:59"
            }

            return{
                moment : moment,
                dateRange: {
                    startDate : startDate,
                    endDate : new moment()._d
                },
                format: moment.localeData().longDateFormat('L'),
                dateNotDisabled : false,
                filter : filter,
                filterReady : false,
                searchButton : false,
                searchString : '',
                searchOption : {
                    selectedIndex : 0,
                    value : ['frame_no', 'qrcode'],
                    text : ['Frame No', 'QR Code']
                },
                selected : {
                    color : null,
                    start_hour : "00:00",
                    end_hour : "23:59",
                },
                filterOption : {
                    vehicleTypes : [],
                    location : [],
                    color : [],
                },
                
            }
        },
        components : {
            DateRangePicker,
            mappingTable,
            VueTimepicker,
            MultiSelect,
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
            this.$store.state.filterUrl = '';
        },
        watch : {
            dateRange : function(){
                let start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                let end_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
                if(this.dateNotDisabled){
                    this.filter.start_date = start_date;
                    this.filter.end_date = end_date;
                } else {
                    delete this.filter.start_date;
                    delete this.filter.end_date;
                }
                this.initialiseFilter();
            },
            'dateNotDisabled' : function(){

                if(this.dateNotDisabled){
                    $('.form-control[readonly]').css('background-color' , 'white')
                    $('.reportrange-text').css('background-color' , 'white')
                    let start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    let end_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    this.filter.start_date = start_date;
                    this.filter.end_date = end_date;
                    this.filter.start_hour = this.selected.start_hour;
                    this.filter.end_hour = this.selected.end_hour;
                } else {
                    $('.form-control[readonly]').css('background-color' , '#DCDCDC')
                    $('.reportrange-text').css('background-color' , '#DCDCDC')
                    delete this.filter.start_date;
                    delete this.filter.end_date;
                    delete this.filter.start_hour;
                    delete this.filter.end_hour;
                }
            },
            'selected.color' : function(){
                if(this.selected.color)
                    this.filter.color = this.selected.color.color_code;
                else
                    this.filter.color = null;
            },
            'selected.start_hour' : function(){
                this.filter.start_hour = this.selected.start_hour;
            },
            'selected.end_hour' : function(){
                this.filter.end_hour = this.selected.end_hour;
            },
            'searchOption.selectedIndex' : function(){
                for (var i = 0; i < this.searchOption.value.length; i++){
                    if(this.searchOption.selectedIndex != i || this.searchString == ''){
                        delete this.filter[this.searchOption.value[i]]
                    } else {
                        this.filter[this.searchOption.value[i]] = this.searchString;
                    }
                }
            },
            'searchString' : function(){
                for (var i = 0; i < this.searchOption.value.length; i++){
                    if(this.searchOption.selectedIndex != i || this.searchString == ''){
                        delete this.filter[this.searchOption.value[i]]
                    } else {
                        this.filter[this.searchOption.value[i]] = this.searchString;
                    }
                }
            },
        },
        mounted(){
            this.initialiseFilter();
            this.getVehicleType();
            this.getLocation();
            this.getColor();
            $('.form-control[readonly]').css('background-color' , '#DCDCDC')
            $('.reportrange-text').css('background-color' , '#DCDCDC')
        },
        methods : {
            
            initialiseFilter(){
                var keys = Object.keys(this.filter);
                let stringUrl = '?';
                var queryParams = this.filter;

                for(var i = 0 ; i < keys.length; i++){
                    if(!queryParams[keys[i]])
                        continue;

                    if((keys[i] == 'frame_no'  || keys[i] == 'type' || keys[i] == 'location') && queryParams[keys[i]] == '')
                        continue;
                    
                    // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
                    //     queryParams[keys[i]] += ":00";

                    stringUrl += `${keys[i]}=${queryParams[keys[i]]}&`;
                    
                }
                this.$store.state.filterUrl = stringUrl;
                this.filterReady = true;
            },
            search(){
                if(this.searchButton)
                    return;
                this.initialiseFilter();
                this.searchButton = true;
                this.$store.state.updateData++;
                this.searchButton = false;
            },
            getVehicleType(){
                this.$http.get('/api/vehicle/vehicle-type')
                .then((resp)=>{
                    this.filterOption.vehicleTypes = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                })
            },
            getLocation(){
                this.$http.get('/api/location/dso-location')
                .then((resp)=>{
                    this.filterOption.location = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                })
            },
            getColor(){
                this.$http.get('/api/color')
                .then((resp)=>{
                    this.filterOption.color = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                })
            }
        }
    }
</script>

<style>
    .form-control[readonly]{
        background-color: white;
    }

    /* Filter Option Card Styling */
    .filter-option-panel .panel-body {
        padding: 16px 20px !important;
    }

    .filter-option-card .filter-row {
        align-items: center;
        margin-left: -10px;
        margin-right: -10px;
    }

    .filter-option-card .filter-row > [class*="col-"] {
        padding-left: 10px;
        padding-right: 10px;
    }

    /* Item 1: Search input group */
    .filter-option-card .search-input-group {
        display: flex;
        width: 100%;
        height: 42px;
    }

    .filter-option-card .search-dropdown {
        height: 42px;
        flex-shrink: 0;
    }

    .filter-option-card .search-dropdown-btn {
        height: 42px !important;
        border: 1px solid #333333 !important;
        border-radius: 4px 0 0 4px !important;
        background-color: #ffffff !important;
        color: #212529 !important;
        font-size: 13px !important;
        font-weight: 500 !important;
        padding: 0 12px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        white-space: nowrap !important;
        line-height: 40px !important;
    }

    .filter-option-card .search-dropdown-btn::after {
        display: none !important;
    }

    .filter-option-card .search-caret {
        font-size: 10px;
        margin-left: 8px;
        color: #333333;
    }

    .filter-option-card .search-text-input {
        height: 42px !important;
        border: 1px solid #ced4da !important;
        border-left: none !important;
        border-radius: 0 4px 4px 0 !important;
        font-size: 13px !important;
        padding: 0 12px !important;
        flex: 1;
        background-color: #ffffff !important;
    }

    .filter-option-card .search-text-input::placeholder {
        color: #adb5bd !important;
        font-size: 13px !important;
    }

    .filter-option-card .search-text-input:focus {
        border-color: #3D7EEA !important;
        box-shadow: none !important;
    }

    /* Common Field Group */
    .filter-option-card .filter-field-group {
        display: flex;
        align-items: center;
        width: 100%;
        height: 42px;
    }

    .filter-option-card .filter-field-label {
        font-size: 13px;
        color: #333333;
        font-weight: 500;
        margin: 0 10px 0 0;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .filter-option-card .vehicle-type-label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 1.15;
        margin-right: 10px;
    }

    .filter-option-card .filter-field-control {
        flex: 1;
        min-width: 0;
    }

    /* MultiSelect 4px border radius and height */
    .filter-option-card .multiselect {
        min-height: 42px;
    }

    .filter-option-card .multiselect__tags {
        min-height: 42px !important;
        height: 42px !important;
        border-radius: 4px !important;
        border: 1px solid #ced4da !important;
        padding: 8px 36px 0 12px !important;
        background-color: #ffffff !important;
    }

    .filter-option-card .multiselect__placeholder {
        color: #adb5bd !important;
        font-size: 13px !important;
        margin-bottom: 0 !important;
        padding-top: 3px !important;
    }

    .filter-option-card .multiselect__single {
        font-size: 13px !important;
        margin-bottom: 0 !important;
        padding-top: 3px !important;
        color: #495057 !important;
    }

    .filter-option-card .multiselect__input {
        font-size: 13px !important;
        padding-top: 3px !important;
    }

    .filter-option-card .multiselect__select {
        height: 40px !important;
        top: 1px !important;
        right: 1px !important;
        width: 36px !important;
        padding: 4px 8px !important;
    }

    .filter-option-card .multiselect__select:before {
        border-color: #6c757d transparent transparent !important;
        border-width: 5px 4px 0 4px !important;
        top: 65% !important;
    }

    /* Date Group */
    .filter-option-card .filter-date-group {
        display: flex;
        align-items: center;
        width: 100%;
        height: 42px;
    }

    .filter-option-card .date-checkbox-label {
        display: flex;
        align-items: center;
        margin-right: 12px;
        cursor: pointer;
        flex-shrink: 0;
        margin-bottom: 0;
    }

    .filter-option-card .date-checkbox-input {
        width: 16px;
        height: 16px;
        margin: 0 8px 0 0;
        cursor: pointer;
        accent-color: #3D7EEA;
        border-radius: 4px;
    }

    .filter-option-card .date-checkbox-text {
        margin: 0;
        font-size: 13px;
        color: #333333;
        font-weight: 500;
        cursor: pointer;
    }

    .filter-option-card .date-picker-control {
        flex: 1;
        min-width: 0;
    }

    .filter-option-card .filter-date-range-picker {
        width: 100% !important;
        display: block !important;
    }

    .filter-option-card .filter-date-range-picker .form-control {
        height: 42px !important;
        border-radius: 4px !important;
        border: 1px solid #ced4da !important;
        padding: 0 12px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        background-color: #ffffff;
        cursor: pointer;
    }

    .filter-option-card .date-picker-slot-inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100%;
    }

    .filter-option-card .date-range-text {
        font-size: 12px;
        color: #495057;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .filter-option-card .date-calendar-icon {
        color: #212529;
        font-size: 14px;
        margin-left: 8px;
        flex-shrink: 0;
    }

    /* Timepicker Group */
    .filter-option-card .filter-time-wrapper {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .filter-option-card .filter-time-group {
        display: flex;
        align-items: center;
        height: 42px;
    }

    .filter-option-card .timepicker-control-wrapper {
        width: 148px;
        flex-shrink: 0;
    }

    .filter-option-card .vue__time-picker {
        width: 148px !important;
        height: 42px !important;
    }

    .filter-option-card .vue__time-picker input.display-time {
        width: 148px !important;
        height: 42px !important;
        border-radius: 4px !important;
        border: 1px solid #ced4da !important;
        font-size: 13px !important;
        color: #495057 !important;
        text-align: center !important;
        padding: 0 24px 0 10px !important;
    }

    .filter-option-card .vue__time-picker .controls {
        right: 4px !important;
    }

    .filter-option-card .vue__time-picker .controls .char {
        font-size: 0.9em !important;
        color: #adb5bd !important;
    }

    /* Disabled State for Date & Timepickers */
    .filter-option-card .disabled-picker,
    .filter-option-card .disabled-picker input,
    .filter-option-card .disabled-picker .form-control,
    .filter-option-card .disabled-picker input.display-time {
        background-color: #eef1f5 !important;
        color: #495057 !important;
        pointer-events: none !important;
        opacity: 1 !important;
        border-color: #ced4da !important;
    }

    /* Search Button */
    .btn-search-custom {
        background-color: #3D7EEA !important;
        border-color: #3D7EEA !important;
        color: #ffffff !important;
        width: 283px !important;
        max-width: 100%;
        height: 42px !important;
        border-radius: 4px !important;
        opacity: 1 !important;
        transform: rotate(0deg);
        font-size: 14px !important;
        font-weight: 500 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 40px !important;
        padding: 0 !important;
        cursor: pointer;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
    }

    .btn-search-custom:hover {
        background-color: #2e6fd8 !important;
        border-color: #2e6fd8 !important;
        color: #ffffff !important;
    }
</style>

<style scoped>
    .searchOptions:hover{
        cursor:pointer;
    }
</style>